import axios from 'axios';
import {
  GET_BANK_DEPOSITS_ACCOUNTS_REQUEST,
  GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS,
  GET_BANK_DEPOSITS_ACCOUNTS_FAILURE,
  GET_BANK_DEPOSIT_FEES_REQUEST,
  GET_BANK_DEPOSIT_FEES_SUCCESS,
  GET_BANK_DEPOSIT_FEES_FAILURE,
  GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST,
  GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS,
  GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE,
  CLEAR_BANK_DEPOSIT_FEE_DETAILS
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getBankDepositsAccounts = () => async dispatch => {
  try {
    dispatch({
      type: GET_BANK_DEPOSITS_ACCOUNTS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/api/cms/v1/bank-deposits-accounts`);

    dispatch({
      type: GET_BANK_DEPOSITS_ACCOUNTS_SUCCESS,
      payload: res.data?.body?.accounts || []
    });

    return { success: true, data: res.data?.body?.accounts || [] };
  } catch (e) {
    dispatch({
      type: GET_BANK_DEPOSITS_ACCOUNTS_FAILURE,
      payload: e.response?.data?.message || 'Hesap bilgileri yüklenemedi'
    });

    return { success: false, error: e.response?.data };
  }
};

export const getBankDepositFees = () => async dispatch => {
  try {
    dispatch({
      type: GET_BANK_DEPOSIT_FEES_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/api/cms/v1/bank-deposit-fees`);

    dispatch({
      type: GET_BANK_DEPOSIT_FEES_SUCCESS,
      payload: res.data?.body?.fees || []
    });

    return { success: true, data: res.data?.body?.fees || [] };
  } catch (e) {
    dispatch({
      type: GET_BANK_DEPOSIT_FEES_FAILURE,
      payload: e.response?.data?.message || 'Banka ücretleri yüklenemedi'
    });

    return { success: false, error: e.response?.data };
  }
};

export const getBankDepositFeeDetails = bankId => async dispatch => {
  try {
    dispatch({
      type: GET_BANK_DEPOSIT_FEE_DETAILS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/api/cms/v1/bank-deposit-fees/banks/${bankId}`);

    dispatch({
      type: GET_BANK_DEPOSIT_FEE_DETAILS_SUCCESS,
      payload: res.data?.body?.bank || null
    });

    return { success: true, data: res.data?.body?.bank || null };
  } catch (e) {
    dispatch({
      type: GET_BANK_DEPOSIT_FEE_DETAILS_FAILURE,
      payload: e.response?.data?.message || 'Banka detayları yüklenemedi'
    });

    return { success: false, error: e.response?.data };
  }
};

export const clearBankDepositFeeDetails = () => ({
  type: CLEAR_BANK_DEPOSIT_FEE_DETAILS
});
